module.exports = __webpack_public_path__ + "static/media/dropdown_icon.2f89f448.svg";